// extracted by mini-css-extract-plugin
export default {"recipeLayout":"Recipe_recipeLayout__OGroy"};